/**
 * Decorator preventing duplicate requests
 * Proper usage: Initialize it once,
 * then use its instance while making request
 *
 * @param {(...any) => Promise} fn
 * @returns {(...any) => Promise}
 */
export default function duplicatePreventor(fn) {
  let isRunning = false;
  return function (...args) {
    if (isRunning) return new Promise();
    isRunning = true;

    return fn(...args).finally(() => {
      isRunning = false;
    });
  };
}
